import { DashboardsPopup } from './dashboard-popup/DashboardsPopup';
import { MobileNavBarButton } from './MobileNavBarButton';

import { PageId } from '@shared/protos/routes';
import { useState } from 'react';

export default function DashboardNavItem({ isPremiumUser }: { isPremiumUser: boolean }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <MobileNavBarButton
        onClick={handleClick}
        icon="ri-dashboard-line"
        label="Dashboards"
        pageId={PageId.dashboard}
        data-testid="dashboard-nav-item-mobile"
      />
      <DashboardsPopup id="dashboards-menu" anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose} isPremiumUser={isPremiumUser} />
    </>
  );
}
